/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc, SCS, debug) {
	'use strict';

	/**
	 * Cookie Opt-out
	 *
	 * @author Zeljko Curcic
	 * @namespace Tc.Module
	 * @class CookieOptOut
	 * @extends Tc.Module
	 */

	Tc.Module.CookieOptOut = Tc.Module.extend({

		cookieName: 'optout',

		/**
		 * Initializes CookieOptOut and attaches events
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.isMobile = SCS.utils.isMobilePage();
			mod.cbox = $ctx.find('#cookieOptOut');
			mod.overlay = $ctx.closest('.ui-dialog-lightbox-content');

			// TODO: Investigate how to make the checkbox work on mobile without adding this line to the module
			if (mod.isMobile) {
				mod.cbox.customInput();
			}

			if ($.getCookie(mod.cookieName) === 1) {
				mod.cbox.prop('checked', true);
			}

			$ctx.on('click', '.secondary-button', function () {
				if (mod.overlay.length) {
					mod.overlay.dialog('close');
				} else if (window.history.length) {
					window.history.back();
				}
			});

			$ctx.on('click', '.primary-button', $.proxy(mod.handleCookie, mod));

			callback();
		},

		handleCookie: function () {
			var mod = this,
				cookieValue = mod.cbox.filter(':checked').length,
				domain = location.hostname.indexOf('.swisscom.ch') >= 0 ? '.swisscom.ch' : null;

			$.setCookie(mod.cookieName, cookieValue, 365, null, domain);
			debug.log('Tc.Module.CookieOptOut >', mod.cookieName, cookieValue, 365, null, domain);

			if (mod.overlay.length) {
				mod.overlay.dialog('close');
			}
		}
	});
}(window.Tc.$, window.Tc, window.SCS = window.SCS || {}, window.debug));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.CookieOptOut.js
// module id = 135
// module chunks = 0